import { render, staticRenderFns } from "./ModalSelectProduct.vue?vue&type=template&id=0ff0b8b0&scoped=true"
import script from "./ModalSelectProduct.vue?vue&type=script&lang=js"
export * from "./ModalSelectProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectProduct.vue?vue&type=style&index=0&id=0ff0b8b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff0b8b0",
  null
  
)

export default component.exports